var ARAutoCompleteInput = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ar-select',{ref:"selectEl",staticClass:"select-wrapper",attrs:{"ar-widget-id":"ar-auto-complete-input","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-auto-complete-input","items":_vm.suggestionItems,"placeholder":_vm.placeholder,"filter-placeholder":_vm.filterPlaceholder,"hide-arrow":"","enable-filter":"","default-filter-string":_vm.realValue,"disabled":_vm.disabled},on:{"filterStringInput":_vm.handleFilterStringInput,"select":_vm.handleItemSelect,"open":function($event){return _vm.$emit('focus')},"close":function($event){return _vm.$emit('blur')}},scopedSlots:_vm._u([{key:"item",fn:function(itemScope){return [_c('div',{style:({
        display: 'flex',
        alignItems: 'center',
        padding: '12px 15px',
        cursor: 'pointer',
        background: itemScope.active ? _vm.$arStyle.color.purple100 : null,
      })},[(itemScope.item.isNewSuggestion && _vm.newSuggestionTemplate)?_c('ar-icon',{style:({
          marginRight: '10px',
        }),attrs:{"name":"circle-plus","height":"16px","color":_vm.$arStyle.color.purple500}}):_vm._e(),_vm._v(" "),(itemScope.item.isNewSuggestion && _vm.newSuggestionTemplate)?_c('ar-text',{style:({
          color: _vm.$arStyle.color.purple500,
        }),attrs:{"size":"xs","text":_vm.newSuggestionText,"allow-html":""}}):_c('ar-text',{style:({
          color: itemScope.active ? _vm.$arStyle.color.purple500 : _vm.$arStyle.color.blueGrey800,
        }),attrs:{"size":"xs","text":itemScope.item.name}})],1)]}}])},[_c('template',{slot:"selected-item"},[_c('div',{style:({
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '0 14px',
      })},[(_vm.realValue)?_c('ar-text',{style:({
          color: _vm.$arStyle.color.blueGrey800,
        }),attrs:{"size":"xs","text":_vm.realValue}}):_c('ar-text',{style:({
          color: _vm.$arStyle.color.blueGrey600,
        }),attrs:{"size":"xs","text":_vm.placeholder}})],1)])],2)},
staticRenderFns: [],
  name: 'AutoCompleteInput',
  props: {
    arWidgetMeta: String,
    value: {
      type: String,
      default: '',
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Please enter',
    },
    newSuggestionTemplate: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `value=${this.realValue};`,
        `placeholder=${this.placeholder};`,
      ].join('');
    },
    newSuggestionText() {
      if (!this.newSuggestionTemplate) { return ''; }
      return this.newSuggestionTemplate.replace('{suggestion}', `<strong>\`${this.realValue}\`</strong>`)
    },
    noMatchSuggestion() {
      const matchSuggestions = this.suggestions.filter(suggestion => {
        return suggestion.toLowerCase() === this.realValue.toLowerCase();
      });
      return matchSuggestions.length === 0;
    },
    suggestionItems() {
      const suggestionItems = this.suggestions.map(input => ({
        name: input,
        value: input,
      }));
      if (this.noMatchSuggestion && this.realValue) {
        return [{
          isNewSuggestion: true,
          name: this.realValue,
          value: this.realValue
        }].concat(suggestionItems);
      } else {
        return suggestionItems;
      }
    },
  },
  data() {
    return {
      realValue: '',
    };
  },
  watch: {
    value: {
      handler: function (val) {
        this.realValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    filterPlaceholder() {
      return this.placeholder;
    },
    focusSelectBox() {
      this.$refs.selectEl.toggleDropdown(true);
    },
    handleFilterStringInput(value) {
      this.realValue = value;
      this.$emit('input', value);
    },
    handleItemSelect(item) {
      this.realValue = item.value;
      this.$emit('input', item.value);
      this.$emit('suggestSelect', item.value);
    },
  },
};

export default ARAutoCompleteInput;
